import { Component, inject, OnInit } from '@angular/core';
import { DomSanitizer, Meta, SafeHtml, Title } from "@angular/platform-browser";
import { NgbAccordionModule } from "@ng-bootstrap/ng-bootstrap";
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-prospective-producers',
    imports: [NgbAccordionModule],
    templateUrl: './prospective-producers.component.html',
    styleUrl: './prospective-producers.component.scss'
})

export class ProspectiveProducersComponent implements OnInit {
  private meta = inject(Meta);
  private title = inject(Title);
  faq = [
    {
      count: 1,
      question: 'Are you accepting new vendors/producers?',
      answer: 'We are always looking for great partners. If you are a business or farm within 150 miles of Philadelphia, Please email us at <a href="mailto:info@phillyfoodworks.com">info@phillyfoodworks.com</a>.'
    },
    {
      count: 2,
      question: 'How can I partner with Philly Foodworks?',
      answer: 'We can partner with local businesses and nonprofits in various ways. Please email <a href="mailto:info@phillyfoodworks.com">info@phillyfoodworks.com</a>,' +
        'and our team will schedule a time to discuss. If you are interested in making bulk purchases of produce boxes please see our <a href="https://ecommerce-pfw.navego.tech/pages/how-it-works/produce-program">Low Cost Produce Program page</a>.'
    },
    {
      count: 3,
      question: 'Can I tour the Philly Foodworks warehouse?',
      answer: 'Yes, we offer scheduled tours of our Philadelphia warehouse. Please email <a href="mailto:info@phillyfoodworks.com">info@phillyfoodworks.com</a>  to arrange a date and time for your organization.\n'
    },
  ];

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.setUpSEOTags();
  }

  private setUpSEOTags() {
    const { baseTitle, baseURL, type } = environment.config.seo;
    const url = 'pages/faq/prospective-producers'
    const component = 'Become a Producer'
    const title = `${component} | ${baseTitle}`;

    // Page title
    this.title.setTitle(title);

    // Open Graph for social networks:
    this.meta.addTag({ property: 'og:title', content: title });
    this.meta.addTag({ property: 'og:url', content: `${baseURL}${url}` });
    this.meta.addTag({ property: 'og:type', content: type });
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
